// extracted by mini-css-extract-plugin
module.exports = {"component":"Options_component__3wkyr","option":"Options_option__1gcEG","input":"Options_input__37v4G"};